/**
 * Helper for modal backdrop click handling that does NOT close the modal
 * when the user is performing a text drag-selection (mousedown inside an
 * input/textarea, mouseup released on the backdrop).
 *
 * Usage:
 *   <div className="fixed inset-0 ..." {...backdropClick(onClose)}>
 *     <div {...stopBackdropPropagation}>
 *       ...modal content...
 *     </div>
 *   </div>
 *
 * The modal closes only when both mousedown AND mouseup happen on the backdrop
 * itself (a real click on the overlay), not when the user drags from inside
 * the modal to outside.
 */
export function backdropClick(closeFn, isDisabled = false) {
  return {
    onMouseDown: e => {
      e.currentTarget.dataset.bdDown = e.target === e.currentTarget ? '1' : '0';
    },
    onMouseUp: e => {
      const wasDown = e.currentTarget.dataset.bdDown === '1';
      e.currentTarget.dataset.bdDown = '0';
      if (wasDown && e.target === e.currentTarget && !isDisabled && typeof closeFn === 'function') {
        closeFn();
      }
    },
  };
}

/**
 * Stop both mousedown and mouseup propagation — apply to the modal CONTENT div
 * so drag-select inside doesn't bubble up to the backdrop.
 */
export const stopBackdropPropagation = {
  onMouseDown: e => e.stopPropagation(),
  onMouseUp: e => e.stopPropagation(),
};
